import { get } from 'lodash-es';

const INITIAL_STATE = {};

// ---
// Selectors.
// ---
export const byBaseUrl = (state: any) => get(state, 'runtimeConfig.baseUrl');

export const byEnabledTracking = (state: any) =>
  get(state, 'runtimeConfig.enabledTracking');

export const byGATrackingID = (state: any) =>
  get(state, 'runtimeConfig.gaTrackingID');

export const byImageResizeUrl = (state: any) =>
  get(state, 'runtimeConfig.imageResizeUrl');

export const byIsSafari = (state: any) =>
  (get(state, 'runtimeConfig.browser') as string)?.includes('Safari');

// ---
// Reducer.
// ---
export const reducer = (state = INITIAL_STATE) => state;
